<template>
	<div class="step-one">
		<stepHeader msg="Välj Leveranssätt"
			:currentStep="1"
			:maxStep="4"
			:useSubtitle="! isActive"
			:useBackgroundColor="false"
		/>
		<deliveryMethodSelector
			:deliveryOption.sync="deliveryOption"
			:isActive="isActive"
			:isShippable=isShippable
			:isCollectable=isCollectable
			:isLoggedIn="isLoggedIn"
			@deliveryOption="setDeliveryOption"
		/>
		<text-button
			v-if="isActive"
			class="continue-btn"
			text="Fortsätt"
			:disabled="deliveryOption === null"
			@click="finished"
		/>
	</div>
</template>

<script>
import bus from 'eventbus';
import stepHeader from './step-header';
import localSessionStorage from 'localSessionStorage';
import deliveryMethodSelector from './delivery-method-selector';
import zipCodeSelector from './zip-code-selector';

export default {
	components: {
		stepHeader,
		zipCodeSelector,
		deliveryMethodSelector,
	},
	props: {
		isActive: {
			type: Boolean,
			default: false,
		},
		isLoggedIn: {
			type: Boolean,
			default: false,
		},
		predefinedCart: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			deliveryOption: null,
			selectedZipCode: 0,
		};
	},
	mounted() {
		const isStoreReservation = localSessionStorage.get('checkout:isStoreReservation');
		if (! this.isShippable) {
			this.setDeliveryOption(1);
		} else if(this.isShippable && ! this.isCollectable) {
			this.setDeliveryOption(2);
		} else {
			this.setDeliveryOption(isStoreReservation === false ? 2 : 1);
		}
	},
	methods: {
		finished () {
			localSessionStorage.set('checkout:isStoreReservation', this.deliveryOption === 1 ? true : false);
			bus.$emit('deliveryOptionChanged', this.deliveryOption);
			bus.$emit('stepUpdated', 2, this.deliveryOption);
		},
		setDeliveryOption (option) {
			this.deliveryOption = option;
			bus.$emit('deliveryOptionChanged', this.deliveryOption);
		},
	},
	computed: {
		cart () {
			if (this.predefinedCart) {
				return this.predefinedCart;
			}
			return this.$store.state.cart;
		},
		isShippable () {
			let shippable = true;
			this.cart.rows.forEach(row => {
				if (! row.product.isShippable) {
					shippable = false;
				}
			});
			return shippable;
		},
		isCollectable () {
			let collectable = true;
			this.cart.rows.forEach(row => {
				if (! row.product.isCollectable) {
					collectable = false;
				}
			});
			return collectable;
		},
	},
	watch: {
		deliveryOption (to) {
			this.$emit('stepSelection', {1: this.deliveryOption === 1 ? 'Hämta i butik' : 'Skicka till mig'});
		},
	}
};
</script>

